
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SarlaftRepository } from '../../../domain/repositories/sarlaft/sarlaft.repository';
import { SarlaftEvaluationInput, SarlaftEvaluationResult } from '../../../domain/interfaces/sarlaft/sarlaft.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

interface SarlaftRequestDto {
  input: { recordId: string };
  product: string;
}

interface SarlaftResponseDto {
  status: number;
  timestamp: string;
  userInfo: string;
  data: SarlaftEvaluationResult;
}

@Injectable()
export class SarlaftRepositoryImplementation extends SarlaftRepository {
  private readonly http = inject(HttpClientService);

  override startEvaluation(input: SarlaftEvaluationInput): Observable<SarlaftEvaluationResult> {
    return this.http
      .postRaw<SarlaftResponseDto>(API_ENDPOINTS.sarlaft.start, this.toRequestDto(input))
      .pipe(map((response) => response.data));
  }

  override pollEvaluation(input: SarlaftEvaluationInput): Observable<SarlaftEvaluationResult> {
    return this.http
      .postRaw<SarlaftResponseDto>(API_ENDPOINTS.sarlaft.poll, this.toRequestDto(input))
      .pipe(map((response) => response.data));
  }

  private toRequestDto(input: SarlaftEvaluationInput): SarlaftRequestDto {
    return { input: { recordId: input.recordId }, product: 'Autos' };
  }
}
